import React from 'react';

import { RHFCheckbox } from '@cowbell/ui';

import classes from './orgProfile.module.css';

interface OrgAttestationProps {
  /** Only meaningful once something has changed, as on the accordion before it. */
  readonly disabled: boolean;
}

/**
 * The policyholder's confirmation that the profile above is accurate.
 *
 * <p>Its own component so the page shell holds layout rather than a form
 * control, and so the shell can be tested without a live form context.
 */
export const OrgAttestation = ({ disabled }: OrgAttestationProps) => {
  return (
    <div className={classes.attestation}>
      <RHFCheckbox
        name="orgContactAttest"
        disabled={disabled}
        label="I verify and confirm that the above information is accurate"
      />
    </div>
  );
};

export default OrgAttestation;
